import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Outbox stats DTO
 */
@CaslSubject(AppSubjectEnum.OUTBOX)
export class OutboxStatsDto extends BaseStatsDto {
	pending!: number;
	leased!: number;
	superseded!: number;
	sent!: number;
	failed!: number;
	deadLettered!: number;
}
